/* el-lang-switcher — behaviour for snippets/el-lang-switcher.liquid (variant B, compact). Bound once per page, so Theme
   Editor section reloads never stack listeners.
   - The chip opens a non-modal <dialog> card: Esc, an outside click or Tab leaving it closes it; arrow keys move between
     languages; focus goes back to the chip.
   - Options are real links. Every link carries the page's query string and hash; a click remembers the choice.
   - Second option = the visitor's own language by location. The server already ordered the list from localization.country;
     this script checks the real country once per visit (Shopify's /browsing_context_suggestions.json), because a visitor
     from outside every market is given the home market's country. A multilingual country (Belgium, Luxembourg, Finland,
     Switzerland) is settled by the browser's language.
   - One quiet suggestion under the chip, only on the default language: the visitor's own language (or the one they chose
     before). Never a redirect, never a modal; dismissal is remembered.
   - Ship to submits on change (a no-JS button sits in <noscript>). */
(function () {
  if (window.__elLang) return;
  window.__elLang = true;

  var doc = document;
  var KEY = 'el_lang';
  var HINT_OFF = 'el_lang_hint_off';
  var GEO = 'el_geo';

  function local(get, k, v) {
    try {
      if (get) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { /* storage blocked: everything still works for this page view */ }
    return null;
  }

  function session(get, k, v) {
    try {
      if (get) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { /* ignore */ }
    return null;
  }

  function head() {
    return doc.querySelector('[data-el-lang][data-where="header"]');
  }

  function isDemo(el) {
    var w = el && el.closest ? el.closest('[data-el-lang]') : null;
    return !!(w && w.hasAttribute('data-demo'));
  }

  // ---------- panel ----------
  function parts(el) {
    var wrap = el && el.closest ? el.closest('[data-el-lang][data-where="header"]') : null;
    return wrap ? { wrap: wrap, btn: wrap.querySelector('[data-el-lang-btn]'), panel: wrap.querySelector('[data-el-lang-panel]'), hint: wrap.querySelector('[data-el-lang-hint]') } : null;
  }

  function openPanel(p) {
    if (!p || !p.panel || p.panel.open) return;
    p.panel.show();
    p.btn.setAttribute('aria-expanded', 'true');
    if (p.hint) p.hint.hidden = true;
    var cur = p.panel.querySelector('.el-lang__link[aria-current="true"]') || p.panel.querySelector('.el-lang__link');
    if (cur) cur.focus({ preventScroll: true });
  }

  function closePanel(p, focusBtn) {
    if (!p || !p.panel || !p.panel.open) return;
    p.panel.close();
    p.btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) p.btn.focus({ preventScroll: true });
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-el-lang-btn]');
    if (btn) {
      var p = parts(btn);
      if (p.panel.open) closePanel(p, false); else openPanel(p);
      return;
    }
    var x = t.closest('[data-el-lang-hint-x]');
    if (x) {
      local(false, HINT_OFF, '1');
      x.closest('[data-el-lang-hint]').hidden = true;
      return;
    }
    var link = t.closest('[data-el-lang] a[data-iso]');
    if (link) {
      var iso = link.getAttribute('data-iso');
      local(false, KEY, iso);
      if (isDemo(link)) {
        // preview only: the demo languages are not published, so show the choice instead of opening a 404
        e.preventDefault();
        doc.querySelectorAll('[data-el-lang] a[data-iso]').forEach(function (a) {
          if (a.closest('[data-el-lang-hint]')) return;
          if (a.getAttribute('data-iso') === iso) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
        doc.querySelectorAll('.el-lang__code').forEach(function (c) { c.textContent = iso.split('-')[0].toUpperCase(); });
        doc.querySelectorAll('[data-el-lang]').forEach(function (w) { w.setAttribute('data-current', iso); });
        var hp = parts(head());
        if (hp && hp.hint) hp.hint.hidden = true;
        if (hp) closePanel(hp, true);
      }
      return;
    }
    var open = doc.querySelector('[data-el-lang-panel][open]');
    if (open && !t.closest('[data-el-lang][data-where="header"]')) closePanel(parts(open), false);
  });

  doc.addEventListener('keydown', function (e) {
    var open = doc.querySelector('[data-el-lang-panel][open]');
    if (!open) {
      if (e.key === 'ArrowDown' && doc.activeElement && doc.activeElement.matches && doc.activeElement.matches('[data-el-lang-btn]')) {
        e.preventDefault();
        openPanel(parts(doc.activeElement));
      }
      return;
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel(parts(open), true);
      return;
    }
    var keys = { ArrowDown: 1, ArrowUp: -1, Home: 0, End: 0 };
    if (!(e.key in keys) || !doc.activeElement || !doc.activeElement.classList.contains('el-lang__link')) return;
    var links = Array.prototype.slice.call(open.querySelectorAll('.el-lang__link'));
    var i = links.indexOf(doc.activeElement);
    var n = e.key === 'Home' ? 0 : e.key === 'End' ? links.length - 1 : (i + keys[e.key] + links.length) % links.length;
    e.preventDefault();
    links[n].focus();
  });

  // Tab leaving the card closes it
  doc.addEventListener('focusout', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('[data-el-lang][data-where="header"]') : null;
    if (!wrap) return;
    window.setTimeout(function () {
      var p = parts(wrap);
      if (p && p.panel && p.panel.open && !wrap.contains(doc.activeElement)) closePanel(p, false);
    }, 0);
  });

  // a <dialog> closed by the browser (form method=dialog, Esc in some engines) keeps aria-expanded honest
  doc.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-el-lang-panel]')) {
      var p = parts(e.target);
      if (p) p.btn.setAttribute('aria-expanded', 'false');
    }
  }, true);

  // Ship to submits on change
  doc.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-el-lang-country]') : null;
    if (sel && sel.form) sel.form.submit();
  });

  // ---------- every language link carries the current query string and hash ----------
  function syncLinks() {
    doc.querySelectorAll('[data-el-lang] a[data-iso]').forEach(function (a) {
      if (!a.hasAttribute('data-href0')) a.setAttribute('data-href0', a.getAttribute('href'));
      a.setAttribute('href', a.getAttribute('data-href0') + window.location.search + window.location.hash);
    });
  }

  // ---------- the visitor's own language, second ----------
  function langsFor(cc, map) {
    var pairs = (map || '').split('|');
    for (var i = 0; i < pairs.length; i++) {
      var kv = pairs[i].split(':');
      if (kv[0] === cc) return (kv[1] || '').split(',');
    }
    return [];
  }

  function pick(cands, offered, primary) {
    var avail = cands.filter(function (c) { return c && c !== primary && offered.indexOf(c) > -1; });
    if (avail.length > 1) {
      var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < prefs.length; i++) {
        var p = String(prefs[i] || '').toLowerCase();
        for (var j = 0; j < avail.length; j++) {
          var c = avail[j].toLowerCase();
          if (c === p || c.split('-')[0] === p.split('-')[0]) return avail[j];
        }
      }
    }
    return avail[0] || '';
  }

  function reorder(w, own) {
    var primary = w.getAttribute('data-primary');
    var rank = (w.getAttribute('data-rank') || '').split(',');
    doc.querySelectorAll('[data-el-lang] [data-el-lang-list]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      var by = {};
      items.forEach(function (li) { by[li.getAttribute('data-iso')] = li; });
      var order = [primary];
      if (own) order.push(own);
      rank.concat(Object.keys(by)).forEach(function (c) {
        if (by[c] && order.indexOf(c) < 0) order.push(c);
      });
      order.forEach(function (c) { if (by[c]) list.appendChild(by[c]); });
    });
    doc.querySelectorAll('[data-el-lang]').forEach(function (x) { x.setAttribute('data-local', own || ''); });
  }

  function detectedCountry() {
    var cached = session(true, GEO);
    if (cached !== null) return Promise.resolve(cached === '-' ? '' : cached);
    if (!window.fetch) return Promise.resolve('');
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, 3000);
    return window.fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        window.clearTimeout(timer);
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        c = c ? String(c).toUpperCase() : '';
        session(false, GEO, c || '-');
        return c;
      }, function () {
        window.clearTimeout(timer);
        return '';
      });
  }

  function decide(w) {
    var primary = w.getAttribute('data-primary');
    var cc = w.getAttribute('data-cc') || '';
    var map = w.getAttribute('data-map');
    var countries = (w.getAttribute('data-countries') || '').split(',');
    var home = w.getAttribute('data-home') || '';
    var offered = Array.prototype.map.call(w.querySelectorAll('[data-el-lang-list] > li'), function (li) { return li.getAttribute('data-iso'); });
    var state = { cc: cc, detected: '', own: pick(langsFor(cc, map), offered, primary), source: 'country' };
    // only a visitor carrying the home market's country can be someone from outside every market: nobody else costs a request
    if (!home || cc !== home) return Promise.resolve(state);
    return detectedCountry().then(function (dc) {
      state.detected = dc;
      // outside every market Shopify hands out the home market's country: then use where the visitor really is.
      // A country the visitor chose themselves (any other country) stands.
      if (dc && cc === home && dc !== home && countries.indexOf(dc) < 0) {
        state.own = pick(langsFor(dc, map), offered, primary);
        state.source = 'outside-markets';
      }
      return state;
    });
  }

  // ---------- the quiet suggestion ----------
  function hint(w, state) {
    var el = w.querySelector('[data-el-lang-hint]');
    if (!el) return;
    el.hidden = true;
    if (local(true, HINT_OFF)) return;
    var primary = w.getAttribute('data-primary');
    if (w.getAttribute('data-current') !== primary) return; // only ever suggest away from the default language
    var chosen = local(true, KEY);
    if (chosen === primary) return; // they picked the default themselves
    var target = chosen && w.querySelector('.el-lang__link[data-iso="' + chosen + '"]') ? chosen : state.own;
    if (!target) return;
    var a = w.querySelector('.el-lang__link[data-iso="' + target + '"]');
    if (!a) return;
    var l = el.querySelector('[data-el-lang-hint-link]');
    l.textContent = a.querySelector('.el-lang__name').textContent.trim();
    l.setAttribute('href', a.getAttribute('href'));
    l.setAttribute('data-href0', a.getAttribute('data-href0') || a.getAttribute('href'));
    l.setAttribute('lang', target);
    l.setAttribute('hreflang', target);
    l.setAttribute('data-iso', target);
    var panel = w.querySelector('[data-el-lang-panel]');
    if (!panel || !panel.open) el.hidden = false;
  }

  function init() {
    syncLinks();
    var w = head();
    if (!w) return;
    decide(w).then(function (state) {
      if (state.own !== (w.getAttribute('data-local') || '')) reorder(w, state.own);
      state.order = Array.prototype.map.call(w.querySelectorAll('[data-el-lang-list] > li'), function (li) { return li.getAttribute('data-iso'); });
      window.__elLangState = state;
      hint(w, state);
      syncLinks();
    });
  }

  window.addEventListener('hashchange', syncLinks);
  window.addEventListener('pageshow', syncLinks);
  doc.addEventListener('shopify:section:load', init);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
